<!--新增坏件单-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256"
  >
    <div ref="print1" style="width: 98%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="140">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">产&nbsp;&nbsp;品&nbsp;&nbsp;名：</td>
          <td colspan="4">
            <el-input placeholder="请选择商品" v-model="form.seedname" size="small" clearable style="width: 300px"
                      @click.native="showGoodDetailSel"
                      @clear="clearSeedCode">
            </el-input>{{form.seedcode}}
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">订单号：</td>
          <td width="140">系统自动生成</td>
          <td align="right" width="80">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</td>
          <td width="220">{{controlData.adddate}}</td>
          <td width="60"></td>
          <td width="140"></td>
        </tr>
        <tr class="noborder" v-if="addtype==1">
          <td align="right" width="60">供应商：</td>
          <td width="140">
            <el-select v-model="controlData.pcustomerserial" placeholder="请选择" size="mini" @change="changepcu">
              <el-option
                v-for="item in ptableData"
                :key="item.customerserial"
                :label="item.deptname"
                :value="item.customerserial">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</td>
          <td width="220">{{controlData.caddress}}</td>
          <td align="right" width="60">联系人&nbsp;&nbsp;&nbsp;:</td>
          <td width="140">{{controlData.clinkman!=null ||
            controlData.clinkmantel!=null?controlData.clinkman+controlData.clinkmantel:" "}}
          </td>
        </tr>
        <tr class="noborder" v-if="addtype==1">
          <td align="right">供应号：</td>
          <td>
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号" @change="scanTracknum"
                      onfocus="this.select()"></el-input>
          </td>
          <td align="right">跟踪号：</td>
          <td>
            <el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请输入跟踪单号"
                      onfocus="this.select()"
            ></el-input>
          </td>
          <td align="right"></td>
          <td></td>
        </tr>
        <tr class="noborder" v-show="showshuliangxuanze">
          <td align="right" width="60">数&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;量:</td>
          <td colspan="1">
            <el-input v-model="num" auto-complete="off" size="mini"></el-input>
            <el-input style="width: 100%" size="small" v-model="goodsbarcode"
                      @change="getBarCode()" placeholder="扫唯一码"
                      onfocus="this.select()"></el-input>
            <div v-for="item in scangoodscode" :key="item.goodsbarcode">{{item.goodsbarcode}}</div>
          </td>
        </tr>
        <tr class="noborder" v-show="showerweitable">
          <td colspan="6">
            <TwoDimensionalTable ref="referweibiao" :cutHeight="311" :erweitable="erweitable"
            ></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable">
          <td colspan="6" style="border:none">
            <el-col :span="2" style="text-align: right">右眼：</el-col>
            <el-col :span="10">
              <TwoDimensionalTable ref="referweibiaoright" :cutHeight="311" :erweitable="erweitableright"
              ></TwoDimensionalTable>
            </el-col>
            <el-col :span="2" style="text-align: right">左眼：</el-col>
            <el-col :span="10">
              <TwoDimensionalTable ref="referweibiaoleft" :cutHeight="311" :erweitable="erweitableleft"
              ></TwoDimensionalTable>
              <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
            </el-col>
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5">
            <textarea style="width: 100%;height: 60px" v-model="controlData.remark"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">确认</el-button>
      <el-button type="warning" @click="importEdit" size="mini">二维表导入</el-button>
      <el-button type="warning" @click="importList" size="mini">列表导入</el-button>
      <a href="./static/file/镜片导入格式.xls">下载模板</a>
      <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
    </div>
  </el-dialog>
</template>


<script>


  import {getRemark} from '@/plugin/ordercommon'
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getPrice} from '@/api/set/goodsprice';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getpcustomerserial} from '@/api/set/csagreement';
  import {addstoragebad} from '@/api/set/warehouse'
  import {getListData} from '@/api/set/jxcstore'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import JxcgooddetailSel from '@/components/set/jxcgooddetail/JxcgooddetailSel';
  import {getDetail} from '@/api/set/jxcstoregoodsbarcode';

  export default {
    name: 'AddStorageBad',
    msg:'仓库岗 添加坏件（供应商多发、正式库转入）',
    data() {
      return {
        book: {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []},
        erweitable: [],//二维表
        erweitableleft: [],//左眼二维表
        erweitableright: [],//右眼二维表
        costpricebook: {},
        dialogFormVisible: false,
        goodsbarcode:'',
        title: "",
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        remark: '',
        cangkucode: '',
        cangkuname: '',
        cangkucodes: [],
        tableData: [
          {column: []},
        ],
        addtype:1,
        tableData1: [],
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {},
        storenumtable: [],
        showtitle1: "none",
        jxcstoreData: [],
        filltemplate: "",
        showzuoyoutable: false,
        showerweitable: false,
        showshuliangxuanze: false,
        num: 0,
        canshowgoodsel: true,
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
        },
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        loading: false,
        loadbylist: false,
        scangoodscode:[]
      }

    },
    methods: {
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
      },
      getBarCode(){
        getDetail({storegoodsbarcode: this.goodsbarcode}).then(response => {
          if (response.data.code == 0&&response.data.obj) {
            var arr = response.data.obj;
            var bc = this.goodsbarcode;
            this.goodsbarcode = '';
            if (response.data.obj.seedcode != this.form.seedcode) {
              this.error('产品编码错误！')
              return
            }

            for (let i in this.scangoodscode) {
              if (this.scangoodscode[i].goodsbarcode == bc) {
                this.error('重复扫码！')
                return
              }
            }
            this.scangoodscode.push({goodsbarcode: bc})
            this.num = this.scangoodscode.length;
          }else{
            this.goodsbarcode = '';
            this.error('产品编码不存在！')
          }
        });
      },
      //供应商单号输入成功后自动跳到跟踪单号框
      scanTracknum() {
        if (this.tracknum) {
          this.$refs.logisticstracknum.focus()
        }
      },
      //获得标题
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "坏件入库单"
        return result
      },
      //清空商品
      clearSeedCode() {
        this.scangoodscode=[]
        this.form.seedcode = ""
        this.form.seedname = ""
        this.form.filltemplate = ""
        this.canshowgoodsel = false
      },


      bindData() {
        this.$refs.treeSeed.bindData(() => {
          // return getGoodsTree({nostock: 1})
          return getGoodsTree()
        })

      },

      //选择供应商
      changepcu(val) {
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == val) {
            this.controlData.pcustomerserial = this.ptableData[i].customerserial
            this.controlData.pcustomer = this.ptableData[i].deptname
            this.controlData.clinkman = this.ptableData[i].linkman
            this.controlData.clinkmantel = this.ptableData[i].linkmantel
            this.controlData.caddress = this.ptableData[i].address
            this.BookContent = []
          }
        }
        if (val) {
          this.getXYRange()
        }
      },

      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },

      //选择商品之后执行
      afterSelectCode(row) {
        this.scangoodscode=[]
        this.form.seedcode = row.seedcode
        this.form.seedname = row.seedname
        this.filltemplate = row.filltemplate
        this.costpricebook = {}
        this.BookContent = []
        this.BookContentLeft = []
        this.BookContentRight = []
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        if (this.filltemplate == '30') {//左右眼
          this.showzuoyoutable = true
          this.showerweitable = false
          this.showshuliangxuanze = false
        } else if (this.filltemplate == '10' || this.filltemplate == '20') {
          this.showzuoyoutable = false
          this.showerweitable = true
          this.showshuliangxuanze = false
        } else if (this.filltemplate == '40') {
          this.showzuoyoutable = false
          this.showerweitable = false
          this.showshuliangxuanze = true
        }

        if (this.form.seedname == "") {
          this.$message({
            message: '请选择货品',
            type: 'warning'
          })
          return
        }
        this.geterweibiao()
      },

      //判断当前供应商是否存在
      geterweibiao() {
        getpcustomerserial(
          {seedcode: this.form.seedcode}).then((response) => {
          this.ptableData = response.data.obj
          this.controlData.pcustomerserial = this.ptableData[0].customerserial
          this.controlData.pcustomer = this.ptableData[0].deptname
          this.controlData.clinkman = this.ptableData[0].linkman
          this.controlData.clinkmantel = this.ptableData[0].linkmantel
          this.controlData.caddress = this.ptableData[0].address
          this.getXYRange()

        })
      },

      getXYRange() {
        getPrice({
          seedcode: this.form.seedcode,
          customerSerial: this.controlData.pcustomerserial,
          filterType: 'cost'
        }).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }
          this.createPriceBook()
        })

      },

      createPriceBook() {
        if (this.filltemplate == 30) {
          this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft)
          this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight)
        } else if (this.filltemplate == '10' || this.filltemplate == '20') {
          this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent)
        }
      },

      getLiuYan(remark) {
        return getRemark(remark);
      },


      show() {
        this.dialogSeeVisible = true;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
        this.BookContent = []
        this.createPriceBook()
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },

      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },

      saveData() {
        this.loading = true
        //根据缓存中oddrequired  true需必填否则不必填
        if (this.addtype==1&&JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
          if (!this.logisticstracknum) {
            this.$message({
              message: '请输入跟踪单号',
              type: 'error'
            })
            this.loading = false
            return
          }
          if (!this.tracknum) {
            this.$message({
              message: '请输入供应商单号',
              type: 'error'
            })
            this.loading = false
            return
          }
        }

        //取出对应的表单详情和数量
        var arr = [];
        if (this.filltemplate == "30") {//左右眼
          for (let i in   this.erweitableleft) {
            let temp = this.erweitableleft[i].filter((t) => {
              t.type = "L"
              return typeof(t.P) != "undefined" && t.P !== ""&&parseInt(t.P)!== 0;
            })
            arr = arr.concat(temp)
          }
          for (let i in   this.erweitableright) {
            let temp = this.erweitableright[i].filter((t) => {
              t.type = "R"
              return typeof(t.P) != "undefined" && t.P !== ""&& parseInt(t.P) !== 0;
            })
            arr = arr.concat(temp)
          }
        }
        else if (this.filltemplate == '10' || this.filltemplate == '20') {//非左右眼
          for (let i in   this.erweitable) {
            let temp = this.erweitable[i].filter((t) => {
              return typeof(t.P) != "undefined" && t.P !== ""&& parseInt(t.P) !== 0;
            })
            arr = arr.concat(temp)
          }
        } else if (this.filltemplate == '40') {
          let packsize = {};
          if (this.num && parseInt(this.num) != 0) {
            packsize.P = this.num;
            arr.push(packsize)
          }
        }
        if (arr.length == 0) {
          this.$message({
            message: '输入数量',
            type: 'warning'
          })
          this.loading = false
          return
        }
        for(let i in this.scangoodscode){
          this.scangoodscode[i].cangkucode=this.controlData.cangkucode;
          this.scangoodscode[i].seedcode=this.form.seedcode;
        }
        var scancodes=JSON.stringify(this.scangoodscode);

        if (arr != 0) {
          addstoragebad({
            jxcforms: JSON.stringify(arr),
            map: JSON.stringify({
              pcustomerserial: this.controlData.pcustomerserial,
              pcustomer: this.controlData.pcustomer,
              cangkuname: this.controlData.cangkuname,
              cangkucode: this.controlData.cangkucode,
              address: this.controlData.address,
              linkman: this.controlData.linkman,
              linkmantel: this.controlData.linkmantel,
              seedcode: this.form.seedcode,
              seedname: this.form.seedname,
              remark: this.controlData.remark,
              tracknum: this.tracknum,
              logisticstracknum: this.logisticstracknum,
              addtype:this.addtype,
              scancodes:scancodes
            })
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.$emit('bindGrid');
              this.$emit('openDetail', {
                erpserial: response.data.erpserial,
                seedcode: this.form.seedcode,
                seedname: this.form.seedname,
                cangkucode: this.controlData.cangkucode,
                filltemplate: this.filltemplate
              });
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
            this.dialogSeeVisible = false;
            //刷新列表
          });
          //

        } else {
          this.$message({
            message: '请选择订单',
            type: 'error'
          })
          this.loading = false
        }

      },


      initData(type) {
        this.addtype=type;//1 供应商多发，2 正式转入
        this.initForm()
        if (this.jxcstoreData && this.jxcstoreData.length > 0) {
          this.controlData.cangkucode = this.jxcstoreData[0].cangkucode
          this.controlData.cangkuname = this.jxcstoreData[0].cangkuname
        }

        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.costpricebook = ""
          this.form.bookstr = ""
          this.form.seedcode = ""
          this.form.seedname = ""
          this.book = {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []}
          this.erweitable = []
        }
      },


      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.scangoodscode=[]
        this.canshowgoodsel = true
        this.controlData = {}
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.BookContent = []
        this.BookContentLeft = []
        this.BookContentRight = []
        this.showzuoyoutable = false
        this.showerweitable = false
        this.showshuliangxuanze = false
        this.filltemplate = ""
        this.index = -99
        this.addvisible = true
        this.form.seedcode = ''
        this.form.seedname = ''
        this.num = 0;
        this.loading = false
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
      },
      //列表导入
      importList() {
        this.loadbylist = true;
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      //导入二维表
      importEdit() {
        this.loadbylist = false;
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              let obj = {}
              if (this.loadbylist) {
                data.forEach((item) => {
                  var pg = JSON.parse(item['光度']);
                  pg.P = parseInt(item['数量']);
                  arr.push(pg)
                })
              } else {
                data.forEach((item) => {
                  let Y = ""
                  for (let X in item) {
                    obj = {}
                    if (X == "球\\柱") {
                      Y = parseFloat(item[X]).toFixed(2)
                    } else {
                      if (typeof parseFloat(item[X]) === 'number' && !isNaN(parseFloat(item[X]))) {
                        obj = {"X": parseFloat(X).toFixed(2), "Y": Y, "P": Math.abs(parseFloat(item[X]))}
                        if (this.type) {
                          obj.type = this.type
                        }
                        arr.push(obj)
                      }
                    }
                  }
                })
              }
            }
            this.BookContent = arr
            this.createPriceBook()
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      }
    },
    mounted() {
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj

      })
    },

    components: {
      TwoDimensionalTable,
      JxcgooddetailSel,
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/warehouse/AddStorageBad.vue